import * as PIXI from "pixi.js";
import { SoundManager } from "../../game/manager/SoundManager";
import { EventHandler } from "../../util/event/EventHandler";
import { FileRequest } from "../file/FileRequest";
import { ImageRequest } from "../image/ImageRequest";
import { AtlasRequest } from "../spine/AtlasRequest";
import { SkeletonRequest } from "../spine/SkeletonRequest";
/*
* AssetLoader.ts
*/
export class AssetLoader {
    constructor(assets) {
        this.soundManager = SoundManager.getInstance();
        this.assets = assets;
        this.loadCount = 0;
        this.soundCompleteHandler = new EventHandler(this.handleSoundComplete, this);
    }
    load() {
        this.loadAssets();
    }
    loadAssets() {
        this.totalFiles = this.assets.length;
        for (let i = 0; i < this.assets.length; i++) {
            this.loadFilePath(this.assets[i]);
        }
    }
    loadFilePath(path) {
        let url = path.getUrl();
        if (path.isSound()) {
            this.loadSound(path);
        }
        else if (path.isImage()) {
            this.loadImage(url);
        }
        else if (path.isSpine()) {
            this.totalFiles++;
            this.loadAtlas(path.getAtlasUrl());
            this.loadSkeleton(url);
        }
        else if (path.isAtlas()) {
            this.loadAtlas(url);
        }
        else {
            this.loadFile(url);
        }
    }
    loadSound(path) {
        this.soundManager.preload(path, this.soundCompleteHandler);
    }
    loadImage(url) {
        let request = new ImageRequest(url);
        request.onComplete(this.handleImageComplete, this);
        request.load();
    }
    loadSkeleton(url) {
        let request = new SkeletonRequest(url);
        request.onComplete(this.handleSkeletonComplete, this);
        request.load();
    }
    loadAtlas(url) {
        let request = new AtlasRequest(url);
        request.onComplete(this.handleAtlasComplete, this);
        request.load();
    }
    loadFile(url) {
        let request = new FileRequest(url);
        request.onComplete(this.handleFileComplete, this);
        request.load();
    }
    handleSoundComplete() {
        this.handleFileComplete();
    }
    handleAtlasComplete() {
        this.handleFileComplete();
    }
    handleImageComplete() {
        this.handleFileComplete();
    }
    handleSkeletonComplete() {
        this.handleFileComplete();
    }
    handleFileComplete() {
        this.loadCount++;
        if (this.onProgress) {
            this.onProgress(this.loadCount / this.totalFiles);
        }
        if (this.onComplete) {
            if (this.loadCount == this.totalFiles) {
                this.onComplete();
            }
        }
    }
    static loadImageFromUrl(url, callback, selfRef) {
        PIXI.Assets.load([url]).then(() => {
            // The image is now loaded and available in the texture cache
            const sprite = PIXI.Sprite.from(url);
            callback.call(selfRef, sprite);
        }).catch((error) => {
            console.error('Error loading the image:', error);
        });
    }
}
//# sourceMappingURL=AssetLoader.js.map